import { render, staticRenderFns } from "./RemovableNote.vue?vue&type=template&id=7444d05f&"
import script from "./RemovableNote.vue?vue&type=script&lang=js&"
export * from "./RemovableNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports